import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RegisterModal from "../../Registration/Modal/RegisterModal";
import { Modal } from 'react-bootstrap';
import Registration from "../../Registration/registration";
import './CardGrid.css'


const CardGrid = (props) => {
    const handleClose = () => setShow(false);
    const handleShow = (id) => {
        setId(id);
        setShow(true);
    };
    const [show, setShow] = useState(false);
    const [id, setId] = useState();
    const [position, setPosition] = useState('');
    const navigate = useNavigate();
    const handleScroller = () => {
        const pos = window.pageYOffset;
        setPosition(pos);
        if (pos === document.documentElement.scrollHeight - window.innerHeight + 15) {
            console.log(pos === document.documentElement.scrollHeight - window.innerHeight + 15)
        }
    }

    useEffect(() => {
        // console.log(window.document.body.offsetHeight + window.innerHeight + 527);
        window.addEventListener('scroll', handleScroller, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroller);
        };
    }, [])

    return (
        <>
        <div className="home-page-card">
            <div className="container mobile-container">
            <h2 className="event-name">{props?.config._0(props?.data)}</h2>
                <div className="row">
                    {props?.data?.map(d => {
                        return <div className='col-md-4'>
                            <div className=" maingrid">
                                {props.config?._poster && props.config?._poster(d)}
                                <div className="card-body homepage-card-body">
                                    <h4 className="card-title">{props?.config?._1(d)}</h4>
                                    <div className="grid-datemonth">
                                        <div className="card-date">
                                            <h3>{props?.config?._2(d)}</h3>
                                            {/* <h3>{d.id}</h3> */}
                                        </div>
                                        <div className="card-month">
                                            <p>{props?.config?._3(d)}</p>
                                            {props?.config?._4(d)}
                                            <span>{props?.config?._5(d)}</span>
                                        </div>
                                    </div>
                                    <div className="card-para">
                                        <p>{props?.config?._6(d)}</p>
                                    </div>
                                    <div className="view-detail">
                                        <button type="button" onClick={()=>handleShow(d.id)} className="register-button">{props?.config?._8(d)}</button>
                                        <button onClick={() => { navigate(`${props?.config?._9(d)}`) }} type="button" className="view-button">{props?.config?._10(d)}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </div>

    
    {/* Registeration Modal */}

      <Modal 
        show={show} 
        onHide={handleClose} 
        centered
      >
            <RegisterModal 
                close = {handleClose}
                id={id}
                heading = 'Register for 5th Annual International Conference & Exhibition'
                para = 'Enter the following details to register now'
            />
      </Modal>
</>
    )
}

export default CardGrid;